<template>
    <div>
        <SingleMulHeader :dataFrom="table.params" @search="searchData" :toPdf="toPdf" :excelShow="false"></SingleMulHeader>

        <Collapse v-show="table.data.length > 0" :value="panelName">
            <Panel v-for="(item, index) in table.data" :key="index" :name="`${item.app_id}`">
                {{ item.app_name }}
                <div slot="content">
                    <Table border :columns="table.columns" :data="item.data" style="margin-top: 12px"></Table>
                </div>
            </Panel>
        </Collapse>
    </div>
</template>

<script>
import SingleMulHeader from './components/single_mul_header.vue'
import { TransTopReq } from '@/api/admin/risk'
import { gameSortMap } from '@/libs/config'
export default {
    name: 'GameLossInfo',
    components: { SingleMulHeader },
    data() {
        return {
            loading: false,
            TransTopReqTimer: null,
            panelName: [],
            timestamp: 0,
            gameSortMap,
            table: {
                params: {
                    platid: 0,
                    app_id: 0,
                    app_ids: [],
                    dataTime: this.getCurrentZeroDay()
                },
                data: [],
                yData: {},
                columns: [
                    {
                        type: 'index',
                        title: '序号',
                        align: 'center',
                        width: 60
                    },
                    {
                        key: 'game_name',
                        width: 110,
                        align: 'center',
                        renderHeader: (h) => this.renderHeader(h, '子游戏', '盘口所有子游戏名称')
                    },
                    {
                        key: 'other',
                        align: 'center',
                        children: [
                            {
                                renderHeader: (h) => this.renderHeader(h, '当天', '筛选时间内，盘口该子游戏的新用户转入赢家数占比'),
                                key: 'new_pay_winner_rate',
                                minWidth: 80,
                                align: 'center',
                                render: (h, params) => {
                                    return h('span', params.row.new_pay_winner_rate ? (params.row.new_pay_winner_rate * 100 || 0).toFixed(2) + '%' : '0.00%')
                                }
                            },
                            {
                                key: 'new_pay_winner_rate_offset',
                                minWidth: 80,
                                align: 'center',
                                render: (h, params) => {
                                    let item = this.getOffsetAndColor(params.row, 'new_pay_winner_rate')
                                    return h('span', { style: { color: item.color } }, (item.result * 100 || 0).toFixed(2) + '%')
                                },
                                renderHeader: (h) => this.renderHeader(h, '环比', '盘口该子游戏的新增转入赢家人数环比【(当日数据-昨日数据)/昨日数据】')
                            }
                        ],
                        renderHeader: (h) => this.renderHeader(h, '新用户转入赢家数占比', '盘口该子游戏的新用户转入赢家数占比')
                    },
                    {
                        key: 'other',
                        minWidth: 80,
                        align: 'center',
                        children: [
                            {
                                key: 'new_pay_bet_num',
                                minWidth: 80,
                                align: 'center',
                                renderHeader: (h) => this.renderHeader(h, '当天', '筛选时间内,盘口该子游戏的新用户充投人数')
                            },
                            {
                                key: 'new_pay_bet_num_offset',
                                minWidth: 80,
                                align: 'center',
                                render: (h, params) => {
                                    let item = this.getOffsetAndColor(params.row, 'new_pay_bet_num')
                                    return h('span', { style: { color: item.color } }, item.result)
                                },
                                renderHeader: (h) => this.renderHeader(h, '环比', '盘口该子游戏的新增充投人数环比(当日数据-昨日数据)')
                            }
                        ],
                        renderHeader: (h) => this.renderHeader(h, '新用户充投人数', '盘口该子游戏的新用户充投人数')
                    },
                    {
                        key: 'other3',
                        align: 'center',
                        children: [
                            {
                                key: 'pay_winner_rate',
                                minWidth: 80,
                                align: 'center',
                                render: (h, params) => {
                                    return h('span', (params.row.pay_winner_rate * 100 || 0).toFixed(2) + '%')
                                },
                                renderHeader: (h) => this.renderHeader(h, '当天', '筛选时间内，盘口该子游戏的转入赢家数占比')
                            },
                            {
                                key: 'winner_rate_offset',
                                minWidth: 80,
                                align: 'center',
                                render: (h, params) => {
                                    let item = this.getOffsetAndColor(params.row, 'pay_winner_rate')
                                    return h('span', { style: { color: item.color } }, (item.result * 100 || 0).toFixed(2) + '%')
                                },
                                renderHeader: (h) => this.renderHeader(h, '环比', '盘口该子游戏的新增转入赢家人数环比(当日数据-昨日数据)')
                            }
                        ],
                        renderHeader: (h) => this.renderHeader(h, '转入赢家数占比', '盘口该子游戏的转入赢家数占比')
                    },
                    {
                        key: 'other4',
                        minWidth: 80,
                        align: 'center',
                        children: [
                            {
                                key: 'pay_bet_num',
                                minWidth: 80,
                                align: 'center',
                                renderHeader: (h) => this.renderHeader(h, '当天', '筛选时间内，盘口该子游戏的转入投注人数')
                            },
                            {
                                key: 'pay_bet_num_offset',
                                minWidth: 80,
                                align: 'center',
                                render: (h, params) => {
                                    let item = this.getOffsetAndColor(params.row, 'pay_bet_num')
                                    return h('span', { style: { color: item.color } }, item.result)
                                },
                                renderHeader: (h) => this.renderHeader(h, '环比', '盘口该子游戏的转入投注人数环比(当日数据-昨日数据)')
                            }
                        ],
                        renderHeader: (h) => this.renderHeader(h, '转入投注人数', '盘口该子游戏的转入投注人数')
                    }
                ]
            }
        }
    },
    methods: {
        //查询数据
        searchData(emitProps) {
            let app_array = [] //原始请求app_id数组
            let http_array = [] //请求数组
            let loading_array = [] //请求完成数组
            if (this.table.params.app_ids.length == 0) {
                app_array = emitProps.appid_list.filter((el) => el.platform == this.table.params.platid).map((item) => item.appid)
            } else {
                app_array = this.copyData(this.table.params.app_ids)
            }
            let stime = this.getSecond(this.table.params.dataTime)
            let etime = this.getSecond(this.table.params.dataTime, false)
            //获取此次请求时间
            let timestamp = new Date().getTime()
            for (let i = 0; i < app_array.length; i++) {
                let app_id = app_array[i]
                let app_name = emitProps.appid_list.find((el) => el.appid == app_id)['appName']
                //当天请求参数
                let params1 = this.getTransTopParams('GetNewGameLossInfo2', { platid: this.table.params.platid, app_id, app_name, stime, etime, general: -1, pack_no: -1, timestamp: timestamp })
                //昨日请求参数
                let params = this.copyData(params1)
                params.param._param.stime = stime - 24 * 60 * 60
                params.param._param.etime = etime - 24 * 60 * 60
                let dataResult = { today: null, yesterday: null }
                loading_array.push(1)
                http_array.push([params, params1])
            }

            //设置请求时间
            this.timestamp = timestamp
            //清空之前数据
            this.table.yData = {}
            this.table.data = []
            this.panelName = []
            //排队列请求
            let max = Math.min(5, http_array.length)
            for (let i = 0; i < max; i++) {
                this.toHttp(http_array, loading_array)
            }
        },
        async toHttp(http_array, loading_array) {
            if (http_array.length > 0) {
                //获取请求参数
                let pList = http_array.shift()
                let [params, params1] = pList
                //请求时间是否当前请求的时间 是则请求
                if (params.timestamp == this.timestamp) {
                    let isEnd = 0
                    this.openTimer()
                    //获取昨日数据组成map
                    TransTopReq(params).then((res) => {
                        res._param.data = res._param.data || []
                        let dataMap = res._param.data.reduce((res, cur) => {
                            cur.new_pay_winner_rate = 0
                            cur.pay_winner_rate = 0
                            res[cur.game_id] = cur
                            return res
                        }, {})
                        let params3 = this.copyData(params)
                        params3.param._func = 'GetGameWinLoseInfo'
                        TransTopReq(params3).then((res3) => {
                            if (params.timestamp == this.timestamp) {
                                for (let key in dataMap) {
                                    let item = dataMap[key]
                                    item.new_pay_bet_num = 0
                                    let find = res3._param.data.find((el) => el.game_id == item.game_id)
                                    if (find) {
                                        item.new_pay_bet_num = find.new_pay_bet_num || 0
                                        item.new_pay_winner_rate = find.new_pay_winner_rate || 0
                                        item.new_win_num = find.new_win_num || 0
                                        item.pay_winner_rate = find.pay_winner_rate || 0
                                    }
                                }
                                this.$set(this.table.yData, params.app_id, dataMap)
                                this.$forceUpdate()
                                isEnd++
                                if (isEnd == 2) loading_array.shift()
                                if (loading_array.length == 0) this.closeTimer()
                            }
                        })
                    })

                    //获取当日数据
                    TransTopReq(params1).then((res1) => {
                        let data = res1._param.data || []
                        data.sort((a, b) => (this.gameSortMap[a.game_id] > this.gameSortMap[b.game_id] ? 1 : -1))
                        let params2 = this.copyData(params1)
                        params2.param._func = 'GetGameWinLoseInfo'
                        TransTopReq(params2).then((res2) => {
                            if (params.timestamp == this.timestamp) {
                                if (data.length > 0) {
                                    data.forEach((el) => {
                                        el.app_id = params.app_id
                                        el.new_pay_bet_num = 0
                                        let find = res2._param.data.find((item) => item.game_id == el.game_id)
                                        if (find) {
                                            el.new_pay_bet_num = find.new_pay_bet_num || 0
                                            el.new_pay_winner_rate = find.new_pay_winner_rate || 0
                                            el.pay_winner_rate = find.pay_winner_rate || 0
                                            el.new_win_num = find.new_win_num || 0
                                        }
                                    })
                                    this.table.data.push({
                                        app_id: params.app_id,
                                        app_name: params.app_name,
                                        data
                                    })
                                    this.panelName.push(`${params.app_id}`)
                                }
                                isEnd++
                                if (isEnd == 2) loading_array.shift()
                                if (loading_array.length == 0) this.closeTimer()
                                if (http_array.length > 0) this.toHttp(http_array, loading_array)
                            }
                        })
                    })
                }
            }
        },
        //透传接口请求参数 请求方法 请求参数
        getTransTopParams(func, param) {
            return {
                mod: 'root',
                platid: param.platid,
                app_id: param.app_id,
                app_name: param.app_name,
                timestamp: param.timestamp,
                param: {
                    _mod: 'manager',
                    _func: func,
                    _param: {
                        ...param
                    }
                }
            }
        },
        toPdf() {
            this.panelName = this.table.data.map((el) => `${el.app_id}`)
            this.$nextTick(() => {
                this.eleToPdf()
            })
        },
        getOffsetAndColor(today, type) {
            let game_id = today.game_id
            let app_id = today.app_id
            let yData = this.table.yData[app_id] || {}
            let yItem = yData[game_id]
            let offset = 0
            if (yItem) {
                offset = yItem[type]
            }
            let result = today[type] - offset
            let color = this.getCompColor(result)
            return { result, color }
        },
        getCompColor(val) {
            return val > 0 ? '#32CD32' : val < 0 ? 'red' : 'black'
        },
        //关闭定时器
        closeTimer() {
            this.loading = false
            clearTimeout(this.TransTopReqTimer)
            this.TransTopReqTimer = null
        },
        //批量请求开启定时器8秒超时
        openTimer() {
            this.closeTimer()
            this.loading = true
            this.TransTopReqTimer = setTimeout(() => {
                this.loading = false
            }, 8000)
        }
    }
}
</script>

<style scoped lang="less"></style>
